export default {
  getPreviewPdfUrl: function (submissionId: string, fileIds: string[]) {
    const queryComponent = fileIds.map(id => `fileId=${id}`).join('&')
    return `/submission/pdf/${submissionId}?${queryComponent}`
  },
}
